import gql from 'graphql-tag';

export const GET_RUNS_FOR_MOVE_GROUPS = gql`
  query GetRunsForMoveGroups(
    $projectName: String!
    $entityName: String!
    $filters: JSONString!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      runs(filters: $filters) {
        edges {
          node {
            id
            user {
              id
              username
            }
            name
            displayName
            group
          }
        }
      }
    }
  }
`;
